import { render } from "./ListManageCustomers.vue?vue&type=template&id=a3cb1006&scoped=true"
import script from "./ListManageCustomers.vue?vue&type=script&lang=ts"
export * from "./ListManageCustomers.vue?vue&type=script&lang=ts"

import "./ListManageCustomers.vue?vue&type=style&index=0&id=a3cb1006&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a3cb1006"

export default script